/*
  ---- custom directive equivalent to v-html ----
  ---- Default allowed tags : B,I,A ----
  ---- Default allowed attribures : href, target ----
  ---- The defaut allowed tags and allowed attributes can be overridden ----
  ---- If the default values has to be overridden pass the value as an object with keys: text, attrs & tags with corresponding values ----
  ---- Param desc: text => string; attrs: array of string; tags: array of string ----
*/

import Vue from 'vue';
let useDOMParser = false;

/* Attributes safe for values like "javascript:" */
const URI_SAFE_ATTRIBUTES = [
  'alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder',
  'summary', 'title', 'value'
]; 

export default {
  inserted: function(el, binding, vnode) {
    if (!binding && !binding.value) {
      return;
    }
    new VHtmlHandler(el, vnode, binding).stripTag();
  },

  bind: function(el, binding, vnode) {
    if (!binding && !binding.value) {
      return;
    }
    new VHtmlHandler(el, vnode, binding).stripTag();
  },

  update: function(el, binding, vnode) {
    if ((el.tagName == 'TEXTAREA' || el.contentEditable == "true") || (!binding && !binding.value)) {
      return;
    }
    new VHtmlHandler(el, vnode, binding).stripTag();
  },
}


class VHtmlHandler {
  el;
  vnode;
  value;
  allowedTags;
  allowedAttrs;
  restrictedTags;
  constructor(el, vnode, binding) {
    this.el = el;
    this.vnode = vnode;
    this.value = binding.value.constructor == Object ? binding.value.text || "" : binding.value || "";
    this.allowedTags = binding.value.tags || ['B', 'I', 'A', 'BR'];
    this.allowedAttrs = binding.value.attrs || [{ tagName: 'A', attrs: ['href', 'target'] }];
  }

  toArray(nl) {
    for (var a = [], l = nl.length; l--; a[l] = nl[l]);
    return a;
  }

  stripAttrs(node) {
    node && node.attributes && this.toArray(node.attributes).forEach((attr) => {
      let filteredAttrs = this.allowedAttrs.filter((k) => k.tagName == node.nodeName)[0];
      filteredAttrs = filteredAttrs && filteredAttrs.attrs || [];
      if(filteredAttrs.indexOf(attr.name) == -1) {
        node.removeAttribute(attr.name);
      }

      // if it is whitelisted by dev - sanity check for un-safe attrs
      if (!URI_SAFE_ATTRIBUTES.includes(attr.name)) {
        // check if attr value contains javascript: prefix
        const dirtyValue = (attr.value || '').trim().replace(/\s/g, '').toLowerCase();
        dirtyValue.includes('javascript:') && node.removeAttribute(attr.name);
      }

      filteredAttrs.indexOf(attr.name) == -1 && node.removeAttribute(attr.name);
    });
    return node;
  }

  unescapeHTML(s) {
    if (typeof(s) !== 'string') {
      s = s + '';
    }
    return s.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  }

  replaceNodes(pnode) {
    if (pnode.childNodes && pnode.childNodes.length > 0) {
      [...pnode.childNodes].forEach((node) => {
        if (node.nodeType == 1) {
          if (this.allowedTags.indexOf(node.nodeName) != -1) {
            node.parentElement.replaceChild(this.stripAttrs(node), node);
            this.replaceNodes(node);
          } else {
            let text = document.createTextNode("");
            node.parentElement.replaceChild(text, node);
          }
        }
      })
    }
    return pnode;
  }

  parseChildNodes(parentNode, output) {
    [...parentNode.childNodes].forEach((node) => {
      if (node.nodeType == 1) {
        let temp = node.children && node.children.length > 0 && this.replaceNodes(node.cloneNode(true)) || node;
        output += this.allowedTags.indexOf(node.nodeName) != -1 ? this.stripAttrs(temp).outerHTML : "";
      }
      if (node.nodeType == 3) {
        output += node.textContent;
      }
    });
    return output;
  }

  checkForRestricedTags(value) {
    let scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    return scriptRegex.test(value) ? value.replace(scriptRegex, "") : value;
  }

  stripeAttrsForAllNodes(parentNode) {
    if(!parentNode || !parentNode.childNodes) return;

    // Strip attributes
    parentNode.childNodes.forEach(node => {
      if(node.childNodes && node.childNodes.length) {
        node.childNodes.forEach(this.stripeAttrsForAllNodes);
      }
      this.stripAttrs(node);
    })
  }

  stripTag() {
    // CHKOUTENGG-3375 - XSS Vulnerability
    const wrapperDOM = initDocument(this.value);
    // let target = document.createElement("div");
    // target.innerHTML = this.unescapeHTML(this.value); //check for &lt; symbols

    let output = this.unescapeHTML(this.parseChildNodes(wrapperDOM, "")); //double check escaped html
    this.el && (this.el.innerHTML = this.checkForRestricedTags(output)); //double check removal of script tags
    // this.stripeAttrsForAllNodes(this.el)
  }
}

/**
 * initDocument
 * Author: cb-saravanan.shanmugam
 *
 * @param  {String} dirty a string of dirty markup
 * @return {Document} a DOM, filled with the dirty markup
 */
const initDocument = function(dirty) {
  /* Create a HTML document */
  let doc;
  let leadingWhitespace;

  /* Use DOMParser to workaround Firefox bug (see comment below) */
  if (useDOMParser) {
    try {
      doc = new DOMParser().parseFromString(dirty, 'text/html');
    } catch (error) {}
  }

  /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
  Safari (see comment below) */
  if (!doc || !doc.documentElement) {
    doc = document.implementation.createHTMLDocument('');
    const { body } = doc;
    body.parentNode.removeChild(body.parentNode.firstElementChild);
    body.outerHTML = dirty;
  }

  if (dirty && leadingWhitespace) {
    doc.body.insertBefore(
      document.createTextNode(leadingWhitespace),
      doc.body.childNodes[0] || null
    );
  }

  return document.getElementsByTagName.call(doc, 'body')[0];
};

(function() {
  try {
    const doc = initDocument(
      '<svg><p><textarea><img src="</textarea><img src=x abc=1//">'
    );
    if (doc.querySelector('svg img')) {
      useDOMParser = true;
    }
  } catch (error) {}
})();



// WEBPACK FOOTER //
// ./src/directives/vhtml.js